<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Amostras</h3>
        <d-link class="btn btn-primary text-white float-right" :to="{ name: 'admin-sample-by-quotation-list', params: { page: 1 } }">
          Voltar para amostragens
        </d-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around flex-wrap">
            <div class="col-12 col-lg-7">
              <h6 class="m-0">Amostras Ativos do Orçamento ID {{ this.$route.params.quotationId }}</h6>
              <h6 class="link"><d-link :to="{ name: 'admin-customer-edit', params: { customerId: customer_id }}">{{ company }}</d-link></h6>
            </div>
            <div class="col-12 col-lg-5">
              <form class="w-100 d-flex">
                <div class="input-group col-5 pl-0">
                  <d-select
                      v-model="pagination.type_id"
                      :options="productType"
                      value-field="id"
                      text-field="name"
                    >
                    </d-select>
                </div>
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Agente, funcionário"
                    aria-label="Search"
                    v-model="pagination.search"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <sample-table :samples="samples.list" />
            </div>
            <pagination
              :total-items="samples.total_items"
              :pagination.sync="pagination"
            ></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import { EQUIPMENT_DEFAULT } from '_constants/equipment';
import SampleTable from '../components/SampleListTable.vue';

export default {
  name: 'sample-list',
  components: {
    Pagination,
    SampleTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        type_id: null,
        quotation_id: this.$route.params.quotationId,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    samples() {
      const { sampleList } = this.$store.state.sample;
      if (sampleList && sampleList.list.length) {
        return sampleList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    company() {
      return this.samples.list[0]?.company_name || '';
    },
    customer_id() {
      return this.samples.list[0]?.customer_id || null;
    },
    productType() {
      const { productType } = this.$store.state.product;
      if (productType && productType.length) {
        return [{ id: null, name: 'Tipos de amostras', slug: 'tipo-de-amostra' }].concat(productType);
      }
      return [{ ...EQUIPMENT_DEFAULT }];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getSampleList',
      'getProductType',
    ]),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getSampleList(this.pagination)
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    getOptions() {
      if (!this.$store.state.product.productType) {
        this.setToggle({ type: 'progress', bool: true });
        this.getProductType()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getOptions();
    this.getList();
  },
  beforeDestroy() {
    Events.$off('update:pagination');
  },

};
</script>

<style lang="scss" scoped>
</style>
